import store from "store";

export const saveStoreValue = (value: 1 | 0) => {
    if (!process.env.WEBPACK) return;
    store.set("singingOctave", value.toString());
};

export const getStoreValue = () => {
    if (!process.env.WEBPACK) return 1;
    return +(store.get("singingOctave") || 1) as (1 | 0);
};
